// extracted by mini-css-extract-plugin
export var indeterminate = "_2h-6";
export var md = "_2h-5";
export var semantic = "_2h-7";
export var sm = "_2h-4";
export var text = "_2h-8";
export var toggleControl = "_2h-0";
export var toggleInput = "_2h-1";
export var toggleSwitch = "_2h-2";
export var xs = "_2h-3";